<template>
	<div>
		<template>
			<el-table :data="currentSessionData" stripe border style="width: 100%;" @row-click="handleCurrentChange">
				<div v-for="(item,index) in tabInformation" :key="index">
					<el-table-column :prop="item.prop" :label="item.label" :width="item.width"></el-table-column>
				</div>
				<!--el-table-column label="操作">
					<template slot-scope="scope">
						<el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
					</template>
				</el-table-column-->
			</el-table>
		</template>
		<!--分页-->
        <el-pagination :current-page="pageIndex" :page-sizes="pageSizes" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="totaltotal"
                       v-on:current-change="pageIndexChange" v-on:size-change="sizeChange">
        </el-pagination>

		<!-- 详情界面 -->
		<!-- <el-dialog :title="showDetailsTitle" :visible.sync="dialogTableVisible" :close-on-click-modal="false">
			<table v-for="(item,index) in OneDeviceDetails" :key="index">
				<tr>
					<td class="name">{{item.name}}</td>
					<td class="value"><pre>{{item.value}}</pre></td>
				</tr>
			</table>
		</el-dialog> -->
        <el-dialog size="tiny" :title="showDetailsTitle" v-model="dialogTableVisible" :visible.sync="dialogTableVisible" :close-on-click-modal="false">
            <el-form :model="deviceDetails" label-width="110px" ref="areaForm" >
                <el-form-item label="UUID:" prop="UUID">
                    <el-input class="dialog_input" v-model="deviceDetails.uuid" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="DeviceId:" prop="DeviceId">
                    <el-input class="dialog_input" v-model="deviceDetails.device_id" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="TvName:" prop="TvName">
                    <el-input class="dialog_input" v-model="deviceDetails.tv_name" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="ClientType:" prop="ClientType">
                    <el-input class="dialog_input" v-model="deviceDetails.client_type" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="CreateTime:" prop="CreateTime">
                    <el-input class="dialog_input" v-model="deviceDetails.createTime" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="Country:" prop="Country">
                    <el-input class="dialog_input" v-model="deviceDetails.country" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="SwVersion:" prop="SwVersion">
                    <el-input class="dialog_input" v-model="deviceDetails.sw_version" :disabled="true"></el-input>
                </el-form-item>
                <!--el-form-item label="Tokens:" prop="Tokens">
                    <el-input type="textarea" :rows="6" class="dialog_input" v-model="deviceDetails.tokens" :disabled="true"></el-input>
                </el-form-item-->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click.native="closeEdit('areaForm')" >确定</el-button>
            </div>
        </el-dialog>
	</div>
</template>

<script>

import { Config } from "@/config/config"
import { mapState } from 'vuex'
import Notify from '../../api/notifyMsg'
import { Country_list } from "@/locale/country_list"

var tableData = []
//var jsonObj
export default {
    name: 'Device',
    components: {

    },
    computed: mapState({
        user: state => state.user
    }),
    props: ['message'],
    data() {
        return {
            tabInformation: [
                {
                    prop: 'session_generate_time',
                    label: 'CreateTime',
                    width: '300'
                },
                {
                    prop: 'uu_id',
                    label: 'UUID',
                    width: '350'
                },
                {
                    prop: 'tv_name',
                    label: 'TvName',
                    width: '200'
                }
            ],
            deviceDetails: {
                uuid: '',
                device_id: '',
                tv_name: '',
                client_type: '',
                country: '',
                city: '',
                sw_version: '',
                //tokens: '',
                createTime: '',
            },
            currentSessionData: [],
            dialogTableVisible: false,
            showDetailsTitle: '设备详情',
            pageIndex: 1,
            pageSizes: [10, 20, 30, 40, 50],
            pageSize: 10,
            totaltotal: 0
        }
    },
    created: function() {
        //this.getSessionData()
    },
    mounted() {
        console.log("mounted session..");
        this.getSessionData()
    },
    watch: {
        'message' (newVal, oldVal) { //监听区域改变
            console.log("origion change to "+this.message)
            this.getSessionData()
        }
    },
    methods: {
        showDevice(session_generate_time, tv_name, uu_id) {
            this.session_generate_time = session_generate_time;
            this.tv_name = tv_name;
            this.uu_id = uu_id;
        },
        handleDetails(index) {
            console.log(index)
            this.OneDeviceDetails[0].value = jsonObj.devices[index].uu_id
            this.OneDeviceDetails[1].value = jsonObj.devices[index].tv_name
            this.OneDeviceDetails[2].value = jsonObj.devices[index].client_type
            this.OneDeviceDetails[3].value = jsonObj.devices[index].country
            this.OneDeviceDetails[4].value = jsonObj.devices[index].city
            this.OneDeviceDetails[5].value = jsonObj.devices[index].device_id
            this.OneDeviceDetails[6].value = jsonObj.devices[index].activate_code
            this.OneDeviceDetails[7].value = jsonObj.devices[index].activate_code_generate_time
            //this.OneDeviceDetails[8].value = jsonObj.devices[index].tokens

            this.dialogTableVisible = true
        },
        closeEdit() {
            this.dialogTableVisible = false
        },
        handleCurrentChange(val) {
            var _this = this;
            console.log("handleCurrentChange " + val.uu_id);
            _this.getDeviceInfo(val.uu_id)

        },
        handleDelete(index, row) {
            console.log(index, row);
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                }).catch(() => {
                    this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        pageIndexChange(pageIndex) {
            console.log("pageIndexChange", pageIndex)
            var _this = this
            _this.pageIndex = pageIndex
            this.pagination()
        },
        sizeChange(pageSize) {
            var _this = this
            _this.pageSize = pageSize
            this.pagination()
        },
        pagination() {
            console.log("pagination")
            this.currentSessionData = []
            var startIndex = (this.pageIndex - 1) * this.pageSize
            var currentPageMaxItemsSize = ((startIndex + this.pageSize) > (this.totaltotal - startIndex)) ? (this.totaltotal - startIndex) : (startIndex + this.pageSize)
            for (var a = startIndex, b = 0; a < currentPageMaxItemsSize + startIndex, b < currentPageMaxItemsSize; a++, b++) {
                this.currentSessionData[b] = tableData[a]
            }
        },
        getSessionData() {
            var _this = this;
            fetch(Config.url + "/api/v1/console/sessions?token=" + _this.user.token)
            .then(res => res.json())
            .then(json => {
                //jsonObj = json;
                console.log("getSessionData json:", json);
                if (json.Error_code === 1000) {
                    var i;
                    // var tableData = []
                    for (i = 0; i <= json.sessions.length - 1; i++) {
                        var session_generate_time = json.sessions[i].session_generate_time
                        var tv_name = json.sessions[i].tv_name
                        var uu_id = json.sessions[i].uu_id
                        tableData[i] = new this.showDevice(session_generate_time, tv_name, uu_id)
                    }
                    this.totaltotal = json.sessions.length
                    this.pagination()
                } else {
                    Notify.errMsgNotify(json.Error_code, _this)
                }
            })
        },
        getDeviceInfo(uu_id) {
            var _this = this;

            fetch(Config.url + "/api/v1/console/devices?uuid=" + uu_id + "&token=" + _this.user.token)
                .then(response => response.json())
                .then(json => {
                    console.log(json)
                    if (json.Error_code === 1000) {
                        if (json.devices.length > 0) {
                            _this.deviceDetails.uuid = json.devices[0].uuid;
                            _this.deviceDetails.device_id = json.devices[0].device_id;
                            _this.deviceDetails.client_type = json.devices[0].client_type;
                            _this.deviceDetails.tv_name = json.devices[0].tv_name;
                            _this.deviceDetails.country = Country_list[parseInt(json.devices[0].country)][1];
                            //var country = Country_list[parseInt(json.devices[i].country)][1];
                            _this.deviceDetails.city = json.devices[0].city;
                            _this.deviceDetails.sw_version = json.devices[0].sw_version;
                            //_this.deviceDetails.tokens = json.devices[0].tokens;
                            //_this.deviceDetails.createTime = json.devices[0].createTime;
                            var timestamp = json.devices[0].create_time;
                            var newDate = new Date();
                            newDate.setTime(timestamp * 1000);
                            _this.deviceDetails.createTime = newDate.toGMTString();
                            _this.deviceDetails.sw_version = json.devices[0].software_version;

                            /*if (json.devices[0].tokens !== null && json.devices[0].tokens.length > 0) {
                                _this.tokens = "device_access_token:" + json.devices[0].tokens[0].device_access_token + "\n "
                                    + "expires_in:" + json.devices[0].tokens[0].expires_in + "\n"
                                    + "refresh_token:" + json.devices[0].tokens[0].refresh_token + "\n"
                                    + "create_time:" + json.devices[0].tokens[0].create_time + "\n"
                                    + "client_id:" + json.devices[0].tokens[0].client_id;
                            }*/
                            _this.dialogTableVisible = true;
                        }
                    } else {
                        Notify.errMsgNotify(json.Error_code, _this)
                    }
                })
        }
    }
}
</script>

<style scoped>

/* 
 .toolbar {
    float: left;
} 

.name {
    width: 45%;
}

.value {
    width: 55%;
} */
.dialog_input {
    width: 87%;
}

</style>


// WEBPACK FOOTER //
// src/components/device/Session.vue